import { Outlet } from "@tanstack/react-router";
import { OutboxToastProvider } from "../hooks/use-outbox-toasts";

export function RootLayout() {
  return (
    // h-dvh (not min-h-screen): the mail app needs a height-bounded shell so
    // its two-pane layout can scroll its own panes internally instead of
    // the whole page scrolling — dvh avoids the classic mobile-Safari
    // 100vh-taller-than-visible-viewport issue that vh has.
    <div className="flex h-dvh flex-col overflow-hidden bg-cream text-ink">
      <header className="flex items-center justify-center border-b border-border px-4 py-3 sm:justify-start">
        <img src="/brand/logo-wordmark.png" alt="One Mile Auto" className="h-8 w-auto sm:h-9" />
      </header>
      {/* Mounted here (not inside MailShell) so the Undo Send countdown
          survives navigating between the list and thread-detail panes —
          see hooks/use-outbox-toasts.tsx. */}
      <OutboxToastProvider>
        <main className="flex min-h-0 flex-1 flex-col">
          <Outlet />
        </main>
      </OutboxToastProvider>
      <footer className="border-t border-border px-4 py-3 text-center text-xs text-muted sm:text-left">
        One Mile Auto &middot; Albuquerque, NM
      </footer>
    </div>
  );
}
